'use strict';
define([], function () {
    function controller(
        $scope,
        $q,
        $state,
        $window,
        $timeout,
        $translate,
        $mdToast,
        $mdDialog,
        KeywordTrackerService,
        CountriesService,
        UserService,
    ) {
        var vm = $scope;
        var destroyed = false;
        var keywordBuilderLoaded = false;
        var keywordBuilderRequest = null;
        vm.frequencyLimit = 0;
        vm.keywordsLimit = 0;
        vm.planReady = false;
        vm.planError = false;
        vm.settingsLoading = true;
        vm.accountKeywordsCounter = 0;
        vm.keywordBuilderOpen = false;
        vm.keywordBuilderLoading = false;
        vm.keywordBuilderSaving = false;
        vm.keywordBuilderLoadError = false;
        vm.keywordBuilderSaveError = false;
        vm.newKeywords = [];
        vm.existingKeywords = [];
        vm.keywordDiscoveryState = {};

        vm.showCustomToast = showCustomToast;
        vm.showDropAlert = showDropAlert;
        vm.openKeywordBuilder = openKeywordBuilder;
        vm.closeKeywordBuilder = closeKeywordBuilder;
        vm.saveNewKeywords = saveNewKeywords;
        vm.retryKeywordLimits = retryKeywordLimits;
        vm.selectedKeywordDestinations = selectedKeywordDestinations;
        vm.keywordBuilderCountry = keywordBuilderCountry;
        vm.keywordBuilderLimit = keywordBuilderLimit;
        vm.keywordBuilderRequiredTracking = keywordBuilderRequiredTracking;
        vm.canSaveNewKeywords = canSaveNewKeywords;
        vm.keywordBuilderKeydown = keywordBuilderKeydown;

        vm.locationController = {
            removeLocation: function (index, ev) {
                var location = vm.locations[index];
                showDropAlert(vm.trackerId, location, index, ev);
            },
            setDevice: function (idDevice) {
                if (!idDevice) {
                    return;
                }
                var listDevice = [
                    {id: 1, name: 'desktop'}, {id: 2, name: 'mobile'}
                ];
                var deviceName = '';
                angular.forEach(listDevice, function (obj) {
                    if (obj.id === idDevice) {
                        deviceName = obj.name;
                    }
                })
                return deviceName;
            },
            setSearchEngine: function (idSearchEngine) {
                if (!idSearchEngine) {
                    return;
                }
                var listSearchEngine = [
                    {id: 1, name: 'Google'}, {id: 2, name: 'Yahoo'}, {id: 4, name: 'Bing'}
                ];
                var searchEngineName = '';
                angular.forEach(listSearchEngine, function (obj) {
                    if (obj.id === idSearchEngine) {
                        searchEngineName = obj.name;
                    }
                })
                return searchEngineName;
            },
            getCountryNameByCountryCode: function (countryCode) {
                return CountriesService.getByCode(countryCode).name;
            }
        };

        function showDropAlert(trackerId, location, index, ev) {
            $mdDialog.show({
                controller: 'ProjectDeleteLocationCtrl',
                templateUrl: "app/modules/project/dialogs/delete-location/delete-location.html",
                targetEvent: ev,
                clickOutsideToClose: true,
                parent: angular.element(document.body),
                locals: {
                    projectId: trackerId,
                    location: location,
                }
            })
                .then(function () {
                    vm.locations.splice(index, 1);
                    vm.keywordsCounter = vm.locations.map(function (location) {
                        return location.count;
                    })
                        .reduce(function (counter, currentValue) {
                            return counter + currentValue;
                        }, 0);
                }, function () {
                    vm.status = 'You cancelled the dialog.';
                });
        }

        vm.emptyConfiguration = '<i class="icon-blackhole custom-message-template-icon"></i>' +
            '<div class="md-subhead m-b p-l p-r">' +
            $translate.instant('project.wizard.no.configuration') +
            '</div>';

        function showCustomToast(string, classIcon) {
            $mdToast.show({
                template:
                    '<md-toast layout="row" flex class="md-toast">' +
                    '   <div><i class="' + classIcon + ' m-r-sm"></i></div>' +
                    '   <div>' + $translate.instant(string) + '</div>' +
                    '</md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }

        function getUserLimits() {
            var dfd = $q.defer();

            UserService.limits()
                .then(function (res) {
                    vm.planReady = true;
                    vm.planError = false;
                    if (res && res.data && res.data.limits && res.data.limits.length) {
                        angular.forEach(res.data.limits, function (service) {
                            if (service.alias === 'rank-tracker-frequency' && service.qtyAllowed) {
                                vm.frequencyLimit = service.qtyAllowed;
                            }

                            if (service.alias === 'rank-tracker-keywords' && service.qtyAllowed) {
                                vm.keywordsLimit = service.qtyAllowed;
                            }
                        });
                    }

                    dfd.resolve();
                })
                .catch(function (err) {
                    vm.planReady = false;
                    vm.planError = true;
                    dfd.reject(err);
                });

            return dfd.promise;
        }

        function getTracker() {
            return KeywordTrackerService
                .getLocations(vm.trackerId)
                .then(function (res) {
                    vm.locations = res && res.data && res.data.locations || [];
                    updateProjectKeywordCount();
                    return vm.locations;
                });
        }

        function updateProjectKeywordCount() {
            vm.keywordsCounter = (vm.locations || []).map(function (location) {
                return Number(location.count) || 0;
            }).reduce(function (counter, currentValue) {
                return counter + currentValue;
            }, 0);
        }

        function availableKeywordSlots() {
            return Math.max(
                0,
                (Number(vm.keywordsLimit) || 0) - (Number(vm.accountKeywordsCounter) || 0)
            );
        }

        function openKeywordBuilder() {
            vm.keywordBuilderOpen = true;
            vm.keywordBuilderLoadError = false;
            vm.keywordBuilderSaveError = false;
            vm.keywordBuilderSaving = false;
            vm.newKeywords = [];
            vm.keywordDiscoveryState = {};
            initializeDestinations();
            ensureKeywordBuilderData();
        }

        function closeKeywordBuilder() {
            if (vm.keywordBuilderSaving) {
                return;
            }
            vm.keywordBuilderOpen = false;
            vm.keywordBuilderLoadError = false;
            vm.keywordBuilderSaveError = false;
        }

        function keywordBuilderKeydown(event) {
            if (event && (event.key === 'Escape' || event.keyCode === 27)) {
                closeKeywordBuilder();
            }
        }

        function ensureKeywordBuilderData() {
            if (keywordBuilderLoaded) {
                return $q.when();
            }
            if (keywordBuilderRequest) {
                return keywordBuilderRequest;
            }
            vm.keywordBuilderLoading = true;
            vm.keywordBuilderLoadError = false;
            var locationsReady = vm.locations && vm.locations.length
                ? $q.when(vm.locations) : getTracker();
            keywordBuilderRequest = locationsReady.then(function () {
                initializeDestinations();
                return $q.all([
                    KeywordTrackerService.getOneProject(vm.trackerId, {}),
                    KeywordTrackerService.keywordCountTracker()
                ]);
            }).then(function (results) {
                if (destroyed) {
                    return;
                }
                var response = results[0];
                var usageResponse = results[1];
                var trackerProject = response && response.data && response.data.trackerProject || {};
                var keywords = Array.isArray(trackerProject.keywords) ? trackerProject.keywords : [];
                vm.existingKeywords = uniqueKeywordNames(keywords);
                vm.accountKeywordsCounter = Number(
                    usageResponse && usageResponse.data && usageResponse.data.keywords
                ) || vm.keywordsCounter || 0;
                keywordBuilderLoaded = true;
            }).catch(function () {
                if (!destroyed) {
                    vm.keywordBuilderLoadError = true;
                }
            }).finally(function () {
                keywordBuilderRequest = null;
                if (!destroyed) {
                    vm.keywordBuilderLoading = false;
                }
            });
            return keywordBuilderRequest;
        }

        function retryKeywordLimits() {
            return getUserLimits()
                .then(function () {
                    return KeywordTrackerService.keywordCountTracker();
                })
                .then(function (response) {
                    vm.accountKeywordsCounter = Number(
                        response && response.data && response.data.keywords
                    ) || 0;
                })
                .catch(function () {
                    vm.planError = true;
                });
        }

        function initializeDestinations() {
            (vm.locations || []).forEach(function (location) {
                var country = location.countryCode
                    ? CountriesService.getByCode(location.countryCode) : null;
                location.selected = true;
                location.countryName = country && country.name || location.countryCode;
                location.engine = locationController.setSearchEngine(location.searchEngineId);
                location.device = locationController.setDevice(location.deviceId);
            });
        }

        function selectedKeywordDestinations() {
            return (vm.locations || []).filter(function (destination) {
                return destination.selected;
            });
        }

        function keywordBuilderLimit() {
            var destinations = selectedKeywordDestinations();
            if (!destinations.length) {
                return 0;
            }
            return Math.floor(availableKeywordSlots() / destinations.length);
        }

        function keywordBuilderCountry() {
            var destinations = selectedKeywordDestinations();
            return destinations.length ? destinations[0].countryCode : null;
        }

        function keywordBuilderRequiredTracking() {
            return (vm.newKeywords || []).length * selectedKeywordDestinations().length;
        }

        function canSaveNewKeywords() {
            return !vm.keywordBuilderLoading && !vm.keywordBuilderSaving &&
                !vm.keywordBuilderLoadError && !vm.keywordBuilderSaveError &&
                vm.newKeywords.length > 0 &&
                selectedKeywordDestinations().length > 0 &&
                keywordBuilderRequiredTracking() <= availableKeywordSlots();
        }

        function saveNewKeywords() {
            if (!canSaveNewKeywords()) {
                return;
            }
            var keywords = vm.newKeywords.slice();
            var locations = selectedKeywordDestinations().map(function (destination) {
                return {
                    countryCode: destination.countryCode,
                    deviceId: destination.deviceId,
                    searchEngineId: destination.searchEngineId
                };
            });
            vm.keywordBuilderSaving = true;
            vm.keywordBuilderSaveError = false;
            KeywordTrackerService.addKeywords(vm.trackerId, keywords, locations)
                .then(function () {
                    vm.existingKeywords = uniqueKeywordNames(
                        vm.existingKeywords.concat(keywords)
                    );
                    vm.accountKeywordsCounter += keywordBuilderRequiredTracking();
                    vm.keywordBuilderOpen = false;
                    vm.newKeywords = [];
                    return getTracker();
                })
                .then(function () {
                    showCustomToast('project.tracker.keywords.added', 'icon-checkmark st-green');
                })
                .catch(function () {
                    vm.keywordBuilderSaveError = true;
                })
                .finally(function () {
                    if (!destroyed) {
                        vm.keywordBuilderSaving = false;
                    }
                });
        }

        function uniqueKeywordNames(keywords) {
            var seen = Object.create(null);
            return (keywords || []).reduce(function (result, item) {
                var keyword = typeof item === 'string' ? item : item && item.keyword;
                keyword = String(keyword || '').trim();
                var lookup = keyword.toLowerCase();
                if (keyword && !seen[lookup]) {
                    seen[lookup] = true;
                    result.push(keyword);
                }
                return result;
            }, []);
        }

        this.$onInit = function () {
            vm.trackerId = this.tracker.id;
            vm.projectId = this.projectId;
            vm.projectUrl = this.projectUrl;
            var builderStorageKey = 'openTrackerKeywordBuilder:' + vm.projectId;
            var openBuilderAfterLoad = !!ctrl.openBuilderOnLoad ||
                $window.localStorage.getItem(builderStorageKey) === '1' ||
                $window.location.search.indexOf('addKeyword=1') >= 0 ||
                $window.location.search.indexOf('addKeyword=true') >= 0;
            $window.localStorage.removeItem(builderStorageKey);
            KeywordTrackerService.keywordCountTracker()
                .then(function (response) {
                    if (!destroyed) {
                        vm.accountKeywordsCounter = Number(
                            response && response.data && response.data.keywords
                        ) || vm.keywordsCounter || 0;
                    }
                })
                .catch(function () {
                    if (!destroyed) vm.accountKeywordsCounter = vm.keywordsCounter || 0;
                });
            getUserLimits()
                .then(function () {
                    return getTracker();
                })
                .then(function () {
                    if (!destroyed) vm.settingsLoading = false;
                    if (openBuilderAfterLoad) {
                        $timeout(openKeywordBuilder, 0);
                    }
                })
                .catch(function (err) {
                    vm.planError = true;
                    if (!destroyed) vm.settingsLoading = false;
                });
        }

        this.$onDestroy = function () {
            destroyed = true;
        };

    }

    controller.$inject = [
        '$scope',
        '$q',
        '$state',
        '$window',
        '$timeout',
        '$translate',
        '$mdToast',
        '$mdDialog',
        'KeywordTrackerService',
        'CountriesService',
        'UserService',
    ];

    return {
        templateUrl: 'app/modules/project/settings/tracker/tracker.html',
        bindings: {
            tracker: '<',
            projectId: '<',
            projectUrl: '<',
            openBuilderOnLoad: '<'
        },
        controller: controller
    }
});
